<script>
import {defineComponent} from 'vue';
import {RouterView} from 'vue-router';
import {useUserStore} from '@/stores/user';
import {refreshToken, verifyToken} from '@/api';

export default {
  components: {
    RouterView,
  },
  async mounted() {
    await this.refreshToken();
    const refreshInMinutes = 20;
    setInterval(async () => {
      await this.refreshToken();
    }, refreshInMinutes * 1000 * 60);
  },
  methods: {
    refreshToken: async function () {
      const userStore = useUserStore();

      if (!userStore.refresh_token) {
        return;
      }

      const ref = await refreshToken(userStore.refresh_token);
      if (ref.status_code !== 200) {
        userStore.logout();
        await this.$router.replace({name: 'sign-out'});
      } else {
        userStore.setAccessToken(ref['response_data']['access']);
      }
    },
  }
}
</script>

<template>
  <RouterView/>
</template>
